import React, { memo } from 'react';
import { CTAButton } from './CTAButton';
export const HeroSection = memo(function HeroSection() {
  const CHECKOUT_URL = '#compra';
  return <section className="relative overflow-hidden min-h-screen flex items-center justify-center px-4 pt-10 pb-16" data-id="element-113">
      <style data-id="element-114">{`
        @keyframes float {
          0%   { transform: translateY(0px); }
          50%  { transform: translateY(-14px); }
          100% { transform: translateY(0px); }
        }
        .animate-float {
          animation: float 4s ease-in-out infinite;
        }
      `}</style>

      {/* Background - LCP candidate */}
      <img src="https://cdn.magicpatterns.com/uploads/ehXocraeJf13oboyH8uykq/ChatGPT_Image_1_abr_2026,_01_47_02.webp" alt="Fondo taller eléctrico" fetchPriority="high" loading="eager" decoding="async" width="1456" height="816" className="absolute inset-0 w-full h-full object-cover opacity-80" data-id="element-115" />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900/30 via-gray-900/40 to-gray-900/80" data-id="element-116" />

      {/* Contenido */}
      <div className="relative z-10 text-center w-full max-w-sm md:max-w-4xl mx-auto flex flex-col items-center" data-id="element-117">
        {/* Badge */}
        <div className="inline-block bg-blue-500/20 border border-blue-500/40 text-blue-400 text-[11px] md:text-xs font-black uppercase tracking-widest px-4 py-1.5 rounded-full mb-6" data-id="element-118">
          ⚡ El Método Eléctrico N°1 de Argentina: De Cero a Profesional
        </div>

        {/* Título Principal */}
        <h1 className="font-black leading-none tracking-tight mb-6" data-id="element-119">
          <span className="block text-[32px] md:text-7xl text-white mb-2 leading-tight" data-id="element-120">
            Dejá de pagar fortunas <br className="hidden md:block" data-id="element-121" />y{' '}
            <span className="text-blue-500" data-id="element-122">tomá el control técnico</span>
          </span>
          <span className="block text-[15px] md:text-2xl text-white/70 font-bold mt-4 leading-relaxed max-w-4xl mx-auto px-4 uppercase tracking-wide" data-id="element-123">
            De cero absoluto a Profesional de la Electricidad:{' '}
            <br className="hidden md:block" data-id="element-124" />
            Dominá tu casa, ahorrá en reparaciones y facturá como experto en 30
            días.
          </span>
        </h1>

        {/* Mockup con levitación */}
        <a href={CHECKOUT_URL} className="animate-float block mb-8 w-full max-w-[300px] md:max-w-[520px] mx-auto group" data-id="element-125">
          <img src="https://cdn.magicpatterns.com/uploads/nLEpS4NnyGQLSrS151uPXv/hf_20260401_023647_9f4fa364-ad82-4991-adac-833ce21ae051_(1).webp" alt="Megapack Eléctrico PRO" className="w-full transition-all duration-500
              drop-shadow-[0_25px_40px_rgba(0,0,0,0.7)]
              group-hover:drop-shadow-[0_25px_50px_rgba(59,130,246,0.3)]
              group-hover:scale-105
              group-hover:brightness-110" width="665" height="371" fetchPriority="high" loading="eager" decoding="async" data-id="element-126" />
        </a>

        {/* CTA */}
        <CTAButton href={CHECKOUT_URL} text="⚡ QUIERO EL MEGAPACK AHORA" subtext="🔒 Compra protegida por MercadoPago — Garantía 30 días" data-id="element-127" />
      </div>
    </section>;
});